import { Injectable, Inject, Optional } from "@angular/core";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MAT_DATE_LOCALE } from "@angular/material/core";
import { Moment } from "@node_modules/moment-timezone";
import * as moment from "jalali-moment";

const jm = (moment as any).default ?? moment;

Date.prototype.toJSON = function () {
    return this.getFullYear() + "-" +
           ("0" + (this.getMonth() + 1)).slice(-2) + "-" +
           ("0" + this.getDate()).slice(-2) + "T" +
           ("0" + this.getHours()).slice(-2) + ":" +
           ("0" + this.getMinutes()).slice(-2) + ":" +
           ("0" + this.getSeconds()).slice(-2) + ".000Z" ;
};

@Injectable()
export class JalaliDateAdapter extends MomentDateAdapter {
  private useJalali = true;

  constructor(@Optional() @Inject(MAT_DATE_LOCALE) locale: string) {
    super(locale);
  }

  setJalaliMode(enabled: boolean) {
    this.useJalali = enabled;
  }

  override getYear(date: any): number {
    return this.useJalali ? jm(date).jYear() : super.getYear(date);
  }

  override getMonth(date: any): number {
    return this.useJalali ? jm(date).jMonth() : super.getMonth(date);
  }

  override getNumDaysInMonth(date: Moment): number {
    if (this.useJalali) {
      let mm = this.getMonth(date);

      if (mm >= 0 && mm <= 5) {
        return 31;
      }
      if (mm >= 6 && mm <= 10) {
        return 30;
      }

      if (jm(date).jIsLeapYear()) {
        return 30;
      }
      return 29;
    } else {
      return super.getNumDaysInMonth(date);
    }
  }

  override getMonthNames(): string[] {
    if (this.useJalali) {
      return [
        "فروردین",
        "اردیبهشت",
        "خرداد",
        "تیر",
        "مرداد",
        "شهریور",
        "مهر",
        "آبان",
        "آذر",
        "دی",
        "بهمن",
        "اسفند",
      ];
    } else {
      //return super.getMonthNames("long");
      return [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
    }
  }

  override getDayOfWeekNames(style: "long" | "short" | "narrow"): string[] {
    if (this.useJalali) {
      switch (style) {
        case "long":
          return [
            "یک شنبه",
            "دو شنبه",
            "سه شنبه",
            "چهار شنبه",
            "پنچ شنبه",
            "جمعه",
            "شنبه",
          ];
        case "short":
          return ["یک", "دو", "سه", "چهار", "پنچ", "جمعه", "شنبه"];
        case "narrow":
          return ["ی", "د", "س", "چ", "پ", "ج", "ش"];
      }
    }
    else {
       switch(style){
        case 'long':
          return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
          case 'short':
          return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
          case 'narrow':
            return ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
      }

    }
  }

  override getDate(date: any): number {
    return this.useJalali ? jm(date).jDate() : super.getDate(date);
  }

  override getFirstDayOfWeek(): number {
    if (this.useJalali){

      return 6;
    }
    else {
      return 0;
    }
  }

  override getYearName(date: Moment): string {
      if(this.useJalali){
        return jm(date).format("jYYYY/jMM/jDD").substring(0, 4)
      }
      else {
        return jm(date).format("YYYY/MM/DD").substring(0, 4)
      }
  }

  override createDate(year: number, month: number, date: number) {
    if (this.useJalali) {
      return jm(`${year}/${month + 1}/${date}`, "jYYYY/jMM/jDD");
    }
    return super.createDate(year, month, date);
  }

  override format(date: any, displayFormat: any): string {
    if (!date) return "";

    return this.useJalali
      ? jm(date).format("jYYYY/jMM/jDD")
      : jm(date).format("YYYY/MM/DD");
  }


}
